module.exports = __webpack_public_path__ + "static/media/IconTemplates_-67.542e766c.svg";